// extracted by mini-css-extract-plugin
module.exports = {"input":"SectionToolsPromo_input__W8iN4"};